<fullscreen-page class="np-detail-layout">
  <div class="np-detail-left">
    <div class="np-detail-header">
      <div class="np-detail-title-row">
        <dx-button
          class="np-detail-back-btn"
          icon="chevronleft"
          stylingMode="text"
          (onClick)="goBack()"
        ></dx-button>

        <div class="np-detail-title text-truncate">
          {{ catalogTitle }}
        </div>
      </div>
    </div>

    <div class="np-detail-body">
      <catalog
        class="np-detail-browse d-block h-100"
        [routeBasePath]="'/dataprocess/golden-record/catalog'"
        [customerIdOverride]="customerIdFromRoute"
        [catalogIdOverride]="catalogIdFromRoute"
      ></catalog>
    </div>
  </div>

  <div class="np-detail-right-spacer"></div>

  <help-column
    class="align-self-stretch {{ systemService.showHelp ? '' : 'd-none' }}"
    style="flex: 1 1;"
  ></help-column>
</fullscreen-page>
